export default function HowItWorks() {
  const steps = [
    {
      icon: 'ri-user-add-line',
      title: 'Inscreva-se',
      description: 'Preencha o formulário e garanta sua vaga no próximo desafio. Vagas limitadas!'
    },
    {
      icon: 'ri-book-open-line',
      title: 'Receba o Material',
      description: 'Acesso imediato ao plano alimentar, treinos e grupo exclusivo de suporte.'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Siga o Plano',
      description: 'Durante 10 dias, siga o plano personalizado com acompanhamento diário.'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Transforme-se',
      description: 'Veja resultados reais em apenas 10 dias e celebre sua conquista!'
    }
  ];

  return (
    <section id="como-funciona" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Como Funciona
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Um processo simples e eficaz que já transformou milhares de vidas. 
            Siga estes 4 passos e comece sua jornada de transformação hoje mesmo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="relative group"
            >
              <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 h-full border border-gray-100">
                <div className="absolute -top-6 left-8 w-12 h-12 bg-gradient-to-br from-teal-400 to-teal-600 rounded-full flex items-center justify-center text-white font-bold text-lg shadow-lg">
                  {index + 1}
                </div>
                
                <div className="mt-8 mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-orange-100 to-orange-200 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    <i className={`${step.icon} text-3xl text-orange-600`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>

              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-3xl text-teal-400"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-3 bg-gradient-to-r from-lime-50 to-teal-50 px-8 py-4 rounded-full border-2 border-lime-300">
            <i className="ri-time-line text-2xl text-teal-600"></i>
            <span className="text-lg font-semibold text-gray-800">
              Próximo desafio começa em <strong className="text-teal-600">dia 7 Janeiro</strong>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
